import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from '../layouts/full-layout/loadable/Loadable';
import AdminQRPage from '../views/admin/qr';
import AdminUsersPage from '../views/admin/users';
import AdminCompaniesPage from '../views/admin/companies';
import AdminMapPage from '../views/admin/map';
import QRPage from '../views/qr';
import AssociateCompanyPage from '../views/company';
import { StreamProvider } from '../stream/StreamProvider';

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import('../layouts/full-layout/FullLayout')));
/* ***End Layouts**** */

const Dashboard = Loadable(lazy(() => import('../views/dashboard')));
const Inbox = Loadable(lazy(() => import('../views/inbox')));
const Huddls = Loadable(lazy(() => import('../views/huddls')));
const Influencers = Loadable(lazy(() => import('../views/influencers')));
const Map = Loadable(lazy(() => import('../views/map')));
const Hollrs = Loadable(lazy(() => import('../views/hollrs')));
const Hollr = Loadable(lazy(() => import('../views/hollr')));

/* ****Admin***** */
const AdminHollrs = Loadable(lazy(() => import('../views/admin/hollrs')));
const AdminHollr = Loadable(lazy(() => import('../views/admin/hollr')));
const AdminReportedHollrs = Loadable(lazy(() => import('../views/admin/reported-hollrs')));
const AdminAssociates = Loadable(lazy(() => import('../views/admin/associates')));
const AdminChannels = Loadable(lazy(() => import('../views/admin/channels')));

/* ****Pages***** */
const Dashboard1 = Loadable(lazy(() => import('../template_views/dashboards/Dashboard1')));
const Dashboard2 = Loadable(lazy(() => import('../template_views/dashboards/Dashboard2')));
const Dashboard3 = Loadable(lazy(() => import('../template_views/dashboards/Dashboard3')));

/* ****Apps***** */
const Chats = Loadable(lazy(() => import('../template_views/apps/chats/Chats')));
const Notes = Loadable(lazy(() => import('../template_views/apps/notes/Notes')));
const Email = Loadable(lazy(() => import('../template_views/apps/email/Email')));
const Shop = Loadable(lazy(() => import('../template_views/apps/shop/Shop')));
const QuillEditor = Loadable(lazy(() => import('../template_views/quill-editor/QuillEditor')));
const Treeview = Loadable(lazy(() => import('../template_views/treeview/Treeview')));
const Pricing = Loadable(lazy(() => import('../template_views/pricing/Pricing')));
const CustomTimeline = Loadable(lazy(() => import('../template_views/timeline/CustomTimeline')));
const CustomTypography = Loadable(lazy(() => import('../template_views/typography/CustomTypography')));
const Calendar = Loadable(lazy(() => import('../template_views/apps/calendar/ACalendar')));
const CustomerEdit = Loadable(lazy(() => import('../template_views/apps/customers/CustomerEdit')));
const CustomerLists = Loadable(lazy(() => import('../template_views/apps/customers/CustomerLists')));
/* ****Tables***** */
const BasicTable = Loadable(lazy(() => import('../template_views/tables/BasicTable')));
const PaginationTable = Loadable(lazy(() => import('../template_views/tables/PaginationTable')));
const EnhancedTable = Loadable(lazy(() => import('../template_views/tables/EnhancedTable')));
const CollapsibleTable = Loadable(lazy(() => import('../template_views/tables/CollapsibleTable')));
const FixedHeaderTable = Loadable(lazy(() => import('../template_views/tables/FixedHeaderTable')));

// form elements
const ExAutoComplete = Loadable(lazy(() => import('../template_views/form-elements/ExAutoComplete')));
const ExButton = Loadable(lazy(() => import('../template_views/form-elements/ExButton')));
const ExCheckbox = Loadable(lazy(() => import('../template_views/form-elements/ExCheckbox')));
const ExDateTime = Loadable(lazy(() => import('../template_views/form-elements/ExDateTime')));
const ExRadio = Loadable(lazy(() => import('../template_views/form-elements/ExRadio')));
const ExSlider = Loadable(lazy(() => import('../template_views/form-elements/ExSlider')));
const ExSwitch = Loadable(lazy(() => import('../template_views/form-elements/ExSwitch')));
const FormWizard = Loadable(lazy(() => import('../template_views/form-layouts/FormWizard')));
// form layouts
const FormLayouts = Loadable(lazy(() => import('../template_views/form-layouts/FormLayouts')));
const FormCustom = Loadable(lazy(() => import('../template_views/form-layouts/FormCustom')));

// widgets
const WidgetFeed = Loadable(lazy(() => import('../template_views/widgets/widget-feed/WidgetFeed')));
const WidgetApps = Loadable(lazy(() => import('../template_views/widgets/widget-apps/WidgetApps')));

// userprofile
const UserProfile = Loadable(lazy(() => import('../template_views/user-profile/UserProfile')));
const ShopDetail = Loadable(lazy(() => import('../template_views/apps/shop-detail/ShopDetail')));

// chart
const LineChart = Loadable(lazy(() => import('../template_views/charts/LineChart')));
const GredientChart = Loadable(lazy(() => import('../template_views/charts/GredientChart')));
const DoughnutChart = Loadable(lazy(() => import('../template_views/charts/DoughnutChart')));
const AreaChart = Loadable(lazy(() => import('../template_views/charts/AreaChart')));
const ColumnChart = Loadable(lazy(() => import('../template_views/charts/ColumnChart')));
const CandlestickChart = Loadable(lazy(() => import('../template_views/charts/CandlestickChart')));
const RadialbarChart = Loadable(lazy(() => import('../template_views/charts/RadialbarChart')));

// icons
const ReactIcons = Loadable(lazy(() => import('../template_views/icons/ReactIcons')));

// Alert
const ExAlert = Loadable(lazy(() => import('../template_views/alert/ExAlert')));

/* ****Routes***** */

const Router = [
  {
    path: '/',
    element: <FullLayout />,
    children: [
      { path: '/', element: <Navigate to="/dashboard" /> },
      { path: '/dashboard', exact: true, element: <Dashboard /> },
      { path: '/huddls', exact: true, element: <StreamProvider><Huddls /></StreamProvider> },
      { path: '/inbox', exact: true, element: <StreamProvider><Inbox /></StreamProvider> },
      { path: '/influencers', exact: true, element: <Influencers /> },
      { path: '/qr', exact: true, element: <QRPage /> },
      { path: '/map', exact: true, element: <Map /> },
      { path: '/hollrs', exact: true, element: <Hollrs /> },
      { path: '/hollr/:hollrId', element: <Hollr /> },
      { path: '/company', exact: true, element: <AssociateCompanyPage /> },

      // admin
      { path: '/admin/hollrs', element: <AdminHollrs /> },
      { path: '/admin/hollr/:hollrId', element: <AdminHollr /> },
      { path: '/admin/reported-hollrs', element: <AdminReportedHollrs /> },
      { path: '/admin/companies', element: <AdminCompaniesPage /> },
      { path: '/admin/associates', element: <AdminAssociates /> },
      { path: '/admin/channels', element: <StreamProvider><AdminChannels /></StreamProvider> },
      { path: '/admin/qr-codes', element: <AdminQRPage /> },
      { path: '/admin/users', element: <AdminUsersPage /> },
      { path: '/admin/map', element: <AdminMapPage /> },

      // template
      { path: '/dashboards/dashboard1', exact: true, element: <Dashboard1 /> },
      { path: '/dashboards/dashboard2', exact: true, element: <Dashboard2 /> },
      { path: '/dashboards/dashboard3', exact: true, element: <Dashboard3 /> },
      { path: '/customers/lists', exact: true, element: <CustomerLists /> },
      { path: '/chats', element: <Chats /> },
      { path: '/notes', element: <Notes /> },
      { path: '/email', element: <Email /> },
      { path: '/shop/lists', element: <Shop /> },
      { path: '/calendar', element: <Calendar /> },
      { path: '/customers/edit', element: <CustomerEdit /> },
      { path: '/tables/basic-table', element: <BasicTable /> },
      { path: '/tables/pagination-table', element: <PaginationTable /> },
      { path: '/tables/enhanced-table', element: <EnhancedTable /> },
      { path: '/tables/collapsible-table', element: <CollapsibleTable /> },
      { path: '/tables/fixed-header-table', element: <FixedHeaderTable /> },
      { path: '/form-layouts/form-layouts', element: <FormLayouts /> },
      { path: '/form-elements/autocomplete', element: <ExAutoComplete /> },
      { path: '/form-elements/button', element: <ExButton /> },
      { path: '/form-elements/checkbox', element: <ExCheckbox /> },
      { path: '/form-elements/date-time', element: <ExDateTime /> },
      { path: '/form-elements/radio', element: <ExRadio /> },
      { path: '/form-elements/slider', element: <ExSlider /> },
      { path: '/form-elements/switch', element: <ExSwitch /> },
      { path: '/form-layouts/form-wizard', element: <FormWizard /> },
      { path: '/widgets/widget-feed', element: <WidgetFeed /> },
      { path: '/widgets/widget-apps', element: <WidgetApps /> },
      { path: '/user-profile', element: <UserProfile /> },
      { path: '/shop/shop-detail', element: <ShopDetail /> },
      { path: '/charts/line-chart', element: <LineChart /> },
      { path: '/charts/gredient-chart', element: <GredientChart /> },
      { path: '/charts/doughnut-pie-chart', element: <DoughnutChart /> },
      { path: '/charts/area-chart', element: <AreaChart /> },
      { path: '/charts/column-chart', element: <ColumnChart /> },
      { path: '/charts/candlestick-chart', element: <CandlestickChart /> },
      { path: '/charts/radialbar-chart', element: <RadialbarChart /> },
      { path: '/react-icons', element: <ReactIcons /> },
      { path: '/form-layouts/form-custom', element: <FormCustom /> },
      { path: '/quill-editor', element: <QuillEditor /> },
      { path: '/treeview', element: <Treeview /> },
      { path: '/pricing', element: <Pricing /> },
      { path: '/timeline', element: <CustomTimeline /> },
      { path: '/typography', element: <CustomTypography /> },
      { path: '/alert', element: <ExAlert /> },
      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
